import { Component, OnInit } from '@angular/core';
import { DocumentsKeyEnum } from '../../../../../../shared/legal-documents/src/lib/legal-documents.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountCreationSteps, FinancialAccountsCreationService } from '@brightside-web/desktop/feature/financial-accounts-core';

@Component({
    selector: 'brightside-web-spending-account-consents',
    templateUrl: './spending-account-consents.component.html',
    styleUrls: ['./spending-account-consents.component.scss'],
    standalone: false
})
export class SpendingAccountConsentsComponent implements OnInit {
  documentsKey = DocumentsKeyEnum.SPENDING_ACCOUNT;

  constructor(private router: Router, private route: ActivatedRoute, private faCreateSvc: FinancialAccountsCreationService) {}

  ngOnInit(): void {}

  termsAccepted($event: boolean) {
    if ($event) {
      this.faCreateSvc.advanceStep(AccountCreationSteps.CONSENTS);
      this.router.navigate(['../create'], { relativeTo: this.route });
    }
  }
}
